import React, { useState, useEffect, useContext } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Slider from "react-slick";
import "./OurFunds.css";
import { BsArrowLeft, BsArrowRight } from "react-icons/bs";
import URLstateContext from "../../../provider/CommonContext";
import Button from "@mui/material/Button";
import animation from "../../../images/jm-animation.gif";
import {
  GetMethodData,
  GetPostMethodData,
  DecryptAESdata,
} from "../../../provider/ServiceProvider";
import { Navigate } from "react-router-dom";
import fixedincome from "../../../images/youtube/FixedIncome.png";
import { Modal } from "react-bootstrap";
import { AiFillCloseCircle } from "react-icons/ai";
function OurFunds() {
  const [FetchData, SetFetchData] = useState("");
  const { BaseURL } = useContext(URLstateContext);
  const [loadingshow, setloadingshow] = useState(false);
  const [FetchDatavdo, setFetchDatavdo] = useState("");
  const [srnolink, Setsrnolink] = useState("");
  const [show, setShow] = useState(false);
  const BlogSlider = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          nextArrow: <BsArrowRight />,
          prevArrow: <BsArrowLeft />,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          nextArrow: <BsArrowRight />,
          prevArrow: <BsArrowLeft />,
        },
      },
    ],
  };

  useEffect(() => {
    setloadingshow(true);
    GetMethodData(BaseURL + "GetCommunicationHome", {}).then((data) => {
      setloadingshow(false);
      if (data.data != null && data.data.length > 0) {
        SetFetchData(DecryptAESdata(data.data));
        setloadingshow(false);
      }
    });
  }, [BaseURL]);

  const RedirectFund = () => {
    // window.location.href = "/Our-Fund";
    window.open = "/Our-Fund";
  };

  const clickyoutube = (event) => {
    setShow(true);
    GetPostMethodData(BaseURL + "GetVideoLink", {
      IVsrno: event,
    }).then((data) => {
      setloadingshow(false);
      if (data.data != null && data.data.length > 0) {
        setFetchDatavdo(DecryptAESdata(data.data));

        setloadingshow(false);
      }
    }, []);
  };

  const handleClosePopup = () => {
    setShow(false);
  };

  return (
    <>
      <section className="blog-sc global-blog-sc">
        <Container>
          <Row>
            <Col sm={12}>
              <div className="section-header">
                <h2>Video Gallery</h2>
                {/* {(FetchData.length === 0) ? <h5 className="errormsgComNew">No Data Available</h5> : ''} */}
              </div>
              <div>
                {loadingshow ? (
                  <div className="textcentervertex" role="status" aria-live="polite" aria-busy="true">
                    <img src={animation} alt="" aria-hidden="true" />
                    <div className="model_popup">Please Wait...</div>
                  </div>
                ) : (
                  <div>
                    {FetchData && FetchData.length === 0 ? (
                      <h5 className="errormsgComNew" role="alert">No Data Available</h5>
                    ) : (
                      <div className="blog-slider our-funds-slider smart-slider no-arrow">
                        <Slider {...BlogSlider} className="fund-slider">
                          {FetchData &&
                            FetchData.map(
                              (
                                {
                                  Title,
                                  caption,
                                  ThumbnailImage,
                                  CommunicationID,
                                },
                                index
                              ) => {
                                const cleanAltText = Title?.split("|")[0]?.trim() || "";
                                return(
                                <div key={index} className="fund-inner zoom">
                                  <h3>{Title}</h3>
                                  {/* <span
                                    onClick={(event) =>
                                      clickyoutube(CommunicationID)
                                    }
                                  >
                                    <img src={ThumbnailImage} alt="thumbnail"></img>
                                    </span> */}
                                    <button
                                        type="button"
                                        onClick={() => clickyoutube(CommunicationID)}
                                        aria-label={`Play video ${cleanAltText}`}
                                        className="video-thumbnail-btn"
                                        style={{padding : "0px"}}
                                      >
                                        <img src={ThumbnailImage} alt={`${cleanAltText}`}/>
                                      </button>
                                    {/* <iframe
                                    src={embeddedlink}
                                    title="YouTube video player"
                                    frameborder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    allowfullscreen
                                  ></iframe> */}
                                </div>

                                )
                              }
                            )}
                        </Slider>
                      </div>
                    )}
                  </div>
                )}
              </div>
              {FetchData === null ? (
                <h5 className="errormsgComNew">No Data Available !!!</h5>
              ) : (
                ""
              )}
              {FetchDatavdo &&
                FetchDatavdo.map(({ Title, LinkLocation }) => (
                  <Modal show={show} className="modal modal-teams">
                    <Modal.Body id="modal_info">
                      <div className="btnDiv">
                        <div className="" onClick={handleClosePopup}>
                          <AiFillCloseCircle className="btncl" />
                        </div>
                      </div>
                      <div className="youtubepopup">
                        <p>{Title}</p>
                        <div>
                          <iframe
                            className="iframe-vdo"
                            src={LinkLocation}
                            title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen
                          ></iframe>
                        </div>
                      </div>
                    </Modal.Body>
                  </Modal>
                ))}

              <div className="know-more-fund-button">
                {/* <a target="_blank" href="https://www.youtube.com/@JMFinancialAMC" className="">
                  View More
                </a> */}
                <a href="/Insights/VideoGallery">
                  View More <i className="fa fa-arrow-circle-o-right"></i>
                </a>
              </div>
              {/* {loadingshow ? <div className="textcentervertex">
                <img src={animation} alt="Loading" />
                <div className="model_popup">Please Wait...</div>
              </div> : ""
              } */}
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default OurFunds;
